import React from 'react'
import { Input, Switch } from 'antd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useContext } from 'react'
import dayjs from 'dayjs'
import styles from './MaxLengthInput.module.css'
import { BuilderContext } from '../../../../store/store.Builder'
import DescriptionVisibleInput from '../DescriptionVisibleInput/DescriptionVisibleInput'
import CustomNumber from '../../../../../../../components/CustomNumber/CustomNumber'

const MaxLengthInput = observer(({ value = [], onChange }) => {
  const builderContext = useContext(BuilderContext)
  // Convertir l'objet observable en objet JavaScript normal
  const maxLength = builderContext.selectedField.max_length

  const handleValueChange = (e) => {
    const numValue = e.target.value ? parseInt(e.target.value) : null
    const updatedField = {
      ...toJS(builderContext.selectedField),
      max_length: numValue,
    }

    builderContext.handleFieldUpdate(updatedField)
  }

  return (
    <div className={styles.container}>
      <div className={styles.switch}>
        <DescriptionVisibleInput value={value} onChange={onChange} />
      </div>

      {value && (
        <div className={styles.container2}>
          <CustomNumber
            name={'max_lenght'}
            value={maxLength || ''}
            onChange={handleValueChange}
            min={1}
            step={1}
          />
        </div>
      )}
    </div>
  )
})

export default MaxLengthInput
